import { render, staticRenderFns } from "./TabPreview.vue?vue&type=template&id=b81f3b8e&scoped=true&"
import script from "./TabPreview.vue?vue&type=script&lang=js&"
export * from "./TabPreview.vue?vue&type=script&lang=js&"
import style0 from "./TabPreview.vue?vue&type=style&index=0&id=b81f3b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81f3b8e",
  null
  
)

export default component.exports